import { render, staticRenderFns } from "./IncomeMonitor.vue?vue&type=template&id=0b04763e&"
import script from "./IncomeMonitor.vue?vue&type=script&lang=js&"
export * from "./IncomeMonitor.vue?vue&type=script&lang=js&"
import style0 from "./IncomeMonitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports